<template>
<div>
    <div class="col-sm-12 d-flex dont-display-mobile-view" style="background:#283677;">
        <div class="d-flex" style="max-width: 1440px; margin: auto !important;">
        <div class="col-sm-6" style="padding-top: 100px; padding-right: 0px; padding-left: 70px; padding-bottom: 100px;"> 
            <h3 class="meet-header text-left">Cense Conversational AI Web Platform</h3>
            <ul class="meet-list mt-5">
                <li>Assist shoppers to find best offers and coupon codes</li>
                <li>Easy retrieval of Order & Tracking Information</li>
                <li>Hassel free integration of Returns & Refunds</li>
                <li>Back in stock notification to customers</li>
                <li>Showcase of products for up-sell/cross-sell based on customer purchases</li>
            </ul>
        </div>
        <div class="col-sm-6 text-center">
        <span class="helper"></span>
            <img src="../assets/img/portal_dashboard_2.png" alt="">
        </div>
        </div>
    </div>
    <div class="col-sm-12 custom-features-mobile-display" style="background:#283677;">
        <h3 class="meet-header text-left mt-3">Cense Conversational AI Web Platform</h3>
        <div class="col-sm-12 text-center mt-auto mb-auto" style="padding: 20px 10px;">
        <span class="helper"></span>
        <img  src="../assets/img/portal_dashboard_2.png" alt="">
        </div>
        <div class="col-sm-12 mt-auto mb-auto"> 
            <ul class="meet-list">
                <li>Assist shoppers to find best offers and coupon codes</li>
                <li>Easy retrieval of Order & Tracking Information</li>
                <li>Hassel free integration of Returns & Refunds</li>
                <li>Back in stock notification to customers</li>
                <li>Showcase of products for up-sell/cross-sell based on customer purchases</li>
            </ul>
        </div>
    </div>
</div>
</template>
<script>
export default {
    name: 'MeetCenseAnalytics'
}
</script>